"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsContext = void 0;
var react_1 = require("react");
var defaultState = {
    readings: {
        gas: [],
        electricity: [],
    },
    supplies: {
        gas: [],
        electricity: [],
    },
    latestBilling: null,
};
exports.MeterReadingsContext = (0, react_1.createContext)(defaultState);
